import { render } from "./FirebaseAuth.vue?vue&type=template&id=04f06d2c"
import script from "./FirebaseAuth.vue?vue&type=script&lang=js"
export * from "./FirebaseAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__